// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pjQ5","requiredAsterisk":"Info_requiredAsterisk__C704P"};